<div
    class="container bg-light page-light"
    >
    @if (bookingDetails) {
        <div
            appVenueColour
            [primaryColour]="venue?.primaryColour"
            class="row"
        >
            <div class="col-md-2 col-lg-3"></div>
            <div class="col-md-8 col-lg-6">
                <div class="vstack gap-4">
                    <div class="vstack align-items-center p-2 bg-white position-sticky top-0" style="z-index: 1020;">
                        <h5 class="m-0 fw-semibold">{{ bookingDetails.venueName }}</h5>
                    </div>
                    <div class="vstack">
                        <h5 class="fw-semibold">It's Time to Select Your Menu Choices</h5>
                        <p class="text-muted">
                            To ensure a smooth and enjoyable dining experience, we kindly ask you to submit menu selections for everyone in your group via this page.
                        </p>
                        <div class="bg-white rounded-2 p-2">
                            <ng-container
                                [ngTemplateOutlet]="bookingSummary"
                                [ngTemplateOutletContext]="{ bookingDetails: bookingDetails }"
                            ></ng-container>
                        </div>
                    </div>

                    @if (menu && bookingDetails) {
                        <div class="vstack gap-2 mb-4">
                            <div class="hstack gap-2 justify-content-between align-items-center">
                                <h5 class="fw-semibold m-0">
                                    {{ menu.displayName }}
                                </h5>
                                <button
                                    type="button"
                                    class="btn btn-outline-secondary"
                                    (click)="openMenuView()"
                                >
                                    View Full Menu
                                </button>
                            </div>
                            <p class="text-muted">
                                {{ menu.description }}
                            </p>
                            <div class="vstack gap-3">
                                <h6 class="mb-0 fw-bold">
                                    Pre-Order
                                </h6>
                                <div class="vstack gap-1">
                                    @if (bookingDetails.partySize) {
                                        <app-menu-choices-progress
                                            [docket]="docket"
                                            [totalCovers]="bookingDetails.partySize"
                                        >
                                        </app-menu-choices-progress>
                                    }
                                </div>
                                @for (i of partyIndexes; track i) {
                                    <div class="rounded bg-white vstack gap-1">
                                        <div class="hstack gap-2 justify-content-between align-items-center">
                                            <div class="px-3 vstack justify-content-center">
                                                <div class="fw-bold">
                                                    {{ docket?.coverChoices?.[i]?.name || ('Person ' + (i + 1)) }}
                                                </div>
                                            </div>
                                            <button
                                                type="button"
                                                class="hstack gap-1 btn btn-link text-decoration-none w-auto"
                                                (click)="openCoverEditor(i)"
                                            >
                                                @if (!hasSelections(i)) {
                                                    Browse Menu <img ngSrc="assets/right/normal.svg" width="16" height="16" />
                                                } @else {
                                                    Edit Choices <img ngSrc="assets/pencil/normal.svg" width="16" height="16" />
                                                }
                                            </button>
                                        </div>
                                        @if (docket?.coverChoices?.[i]?.notes) {
                                            <div class="px-3 text-break text-muted">
                                                {{ docket?.coverChoices?.[i]?.notes }}
                                            </div>
                                        }
                                        @if (selectedViews.length > i && selectedViews[i].length > 0) {
                                            <div class="px-2 mb-2 vstack gap-2">
                                                @for (v of selectedViews[i]; track $index) {
                                                    <div class="px-3 py-2 bg-light rounded">
                                                        <div class="fw-semibold">
                                                            {{ v.productName }}
                                                        </div>
                                                        @if (v.modifierNames) {
                                                            <div class="small text-muted">{{ v.modifierNames }}

                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
    </div> }
</div>

<ng-template
    #bookingSummary
    let-bookingDetails="bookingDetails"
>
    <div class="vstack gap-2">
        <div class="fw-semibold px-2 py-1 rounded-1 bg-light">
            Booking Summary
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Table for
            </label>
            <div class="text-truncate fw-semibold">
                {{ bookingDetails.partySize | i18nPlural: partySizePluralMapping }}
                ·
                {{ bookingDetails.dateTime | date: 'mediumDate' }}
            </div>
        </div>
        <div *ngIf="bookingDetails.requiresWheelchairAccess || bookingDetails.requiresDogFriendly || bookingDetails.requiresPramAccessible || bookingDetails.requiresHighchairFriendly" class="px-2 hstack gap-1 justify-content-between">
            <label>Booking Requirements</label>
            <div class="text-truncate fw-semibold">
                <ng-container *ngIf="bookingDetails.requiresWheelchairAccess">Wheelchair Access </ng-container>
                <ng-container *ngIf="bookingDetails.requiresDogFriendly">Dog Friendly</ng-container>
                <ng-component *ngIf="bookingDetails.requiresPramAccessible">Pram Accessible</ng-component>
                <ng-component *ngIf="bookingDetails.requiresHighchairFriendly">Highchair Friendly</ng-component>
            </div>
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Booking Type
            </label>
            <div
                class="text-truncate fw-semibold"
            >
                <ng-container
                    *ngIf="bookingDetails.eventId === null"
                >
                    Standard Booking
                </ng-container>
                <ng-container
                    *ngIf="bookingDetails.eventId !== null"
                >
                    {{ bookingDetails.eventName }}
                </ng-container>
            </div>
        </div>
        <div
            *ngIf="bookingDetails.reasonId !== null"
            class="px-2 hstack gap-1 justify-content-between"
        >
            <span class="flex-shrink-0">
                Reason for your visit
            </span>
            <div
                class="text-truncate fw-semibold"
            >
                {{ bookingDetails.reasonName }}
            </div>
        </div>
        <div
            *ngIf="bookingDetails.areaName !== null"
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Seating Area
            </label>
            <div class="text-truncate fw-semibold">
                {{ bookingDetails.areaName }}
            </div>
        </div>
        <div
            class="px-2 hstack gap-1 justify-content-between"
        >
            <label>
                Time
            </label>
            <div
                class="text-truncate fw-semibold"
            >
                {{ bookingDetails.dateTime | date: 'shortTime' }}
            </div>
        </div>
    </div>
</ng-template>
